import { useAppSelector } from "../../hooks/redux-hooks";
import ClassicRecordingView, { type ClassicRecordingViewProps } from "./ClassicRecordingView.component";
import QuickStartRecordingCard from "./QuickStartRecordingCard.component";

type ActiveRecordingViewProps = ClassicRecordingViewProps & {
  /** Quick Start's one-click Submit: stops the recording if it is still running, then submits. */
  handleStopAndSubmit: () => void;
};

/** The sidebar while recording: Quick Start's one-click card for accounts a pulled EHR schedule reaches, else the classic one. */
const ActiveRecordingView = ({ handleStopAndSubmit, ...props }: ActiveRecordingViewProps) => {
  const quickStart = useAppSelector((state) => state.auth.userInfo.has_ehr_schedule === true);
  return quickStart ? (
    <QuickStartRecordingCard {...props} handleSubmitAudio={handleStopAndSubmit} />
  ) : (
    <ClassicRecordingView {...props} />
  );
};

export default ActiveRecordingView;
